/*
  Carries campaign attribution from the landing URL onto outbound Calendly links.

  Params are captured on the landing page and kept in sessionStorage, so a visitor
  who arrives on an ad URL, browses, then clicks "Book an appointment" still hands
  Calendly the attribution.

  Last touch wins outright: a landing URL carrying any tracking param replaces the
  stored set rather than merging into it. Merging would let a leftover utm_content
  or gclid from an earlier click ride along with a later campaign, crediting one
  channel's click ID to another.

  Calendly only stores utm_* and salesforce_uuid against the invitee, so the Google
  click ID is sent twice: as gclid (readable in the raw URL) and mirrored into
  salesforce_uuid, which is what actually lands in booking notifications, the events
  export and webhooks — the field to join on for offline conversion import.
*/
(function () {
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid'];
  var STORE = 'pd_attrib';
  var params;

  try {
    params = JSON.parse(sessionStorage.getItem(STORE));
  } catch (e) {
    params = null;
  }

  // Anything other than a plain object (corrupt or foreign value) is discarded:
  // Object.keys() on a string would otherwise spread its characters onto links.
  if (!params || typeof params !== 'object' || Array.isArray(params)) params = {};

  var query = new URLSearchParams(window.location.search);
  var incoming = {};

  KEYS.forEach(function (key) {
    var value = query.get(key);
    if (value) incoming[key] = value;
  });

  if (Object.keys(incoming).length) {
    params = incoming;

    try {
      sessionStorage.setItem(STORE, JSON.stringify(params));
    } catch (e) {
      // Private browsing / storage disabled — decorate this page view only.
    }
  }

  if (!Object.keys(params).length) return;

  function decorate() {
    document.querySelectorAll('a[href*="calendly.com"]').forEach(function (link) {
      var url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }

      Object.keys(params).forEach(function (key) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, params[key]);
      });

      if (params.gclid && !url.searchParams.has('salesforce_uuid')) {
        url.searchParams.set('salesforce_uuid', params.gclid);
      }

      link.href = url.toString();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorate);
  } else {
    decorate();
  }
})();
